<template>
    <div class="form-group">
        <label v-if="label">{{label}}</label>
        <img :src="path" :alt="alt" class="img-thumbnail form-control-plaintext" />
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
            },

            path: {
                type: String,
                required: true
            },

            alt: {
                type: String,
            }
        }
    };

</script>

<style>
.img-thumbnail{
    width: auto !important;
    height: 150px !important;
}
</style>
